import { CheckCircle2, AlertTriangle, Clock } from "lucide-react";

export const JobsServices = ({ crons, services, collections }) => (
  <div className="space-y-6">
    <div>
      <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">Scheduled background jobs</p>
      <ul className="space-y-2" data-testid="sitemap-crons">{crons.map((c) => (
        <li key={c.name} className="rounded-xl border border-slate-200 p-3 text-sm">
          <p className="flex items-center gap-2 font-semibold text-[#12234A]"><Clock size={14} className="text-[#F5551E]" /> {c.name}
            <span className="font-mono text-[11px] font-normal bg-slate-100 rounded px-1.5 py-0.5">{c.schedule}</span>
            {!c.enabled && <span className="text-[11px] text-red-600">disabled</span>}</p>
          <p className="text-slate-500 mt-0.5">{c.description}</p>
          <p className="font-mono text-[11px] text-slate-400 mt-0.5">{c.endpoint}</p>
        </li>
      ))}</ul>
    </div>
    <div>
      <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">Connected services</p>
      <ul className="grid sm:grid-cols-2 gap-2" data-testid="sitemap-services">{services.map((s) => (
        <li key={s.name} className="rounded-xl border border-slate-200 p-3 text-sm">
          <p className="flex items-center gap-1.5 font-semibold text-[#12234A]">
            {s.configured ? <CheckCircle2 size={14} className="text-emerald-600" /> : <AlertTriangle size={14} className="text-amber-600" />} {s.name}
          </p>
          <p className="text-slate-500 mt-0.5">{s.purpose}</p>
          {s.keys.length > 0 && <p className="font-mono text-[11px] text-slate-400 mt-0.5">{s.keys.join(", ")} {s.configured ? "· set" : "· missing"}</p>}
        </li>
      ))}</ul>
    </div>
    <div>
      <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">Database collections ({collections.length})</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-1" data-testid="sitemap-collections">{collections.map((c) => (
        <div key={c.name} className="flex justify-between text-[13px] border-b border-slate-50 py-0.5">
          <span className="font-mono text-slate-700 truncate">{c.name}</span><span className="tabular-nums text-slate-400">{c.count.toLocaleString()}</span>
        </div>
      ))}</div>
    </div>
  </div>
);
